import "./RequestService.module.css";
import Header from "@/reusable_sections/Header";
import InquiryGateway from "./sections/InquiryGateway";
import OurServiceArea from "./sections/OurServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function RequestServicePage() {
  return <div>
      <Header />
      <InquiryGateway />
      <OurServiceArea />
      <Footer />
    </div>;
}